import http from "../../http-common";

const getUsers = async () => {
  return await http
    .get("/admin/users/")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getUsersHighlight = async (query) => {
  return await http
    .get("/admin/users/highlight", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getUser = async (id) => {
  return await http
    .get(`/admin/users/${id}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const blockUser = async (id) => {
  return await http
    .post(`/admin/users/${id}/block`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const unblockUser = async (id) => {
  return await http
    .post(`/admin/users/${id}/unblock`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getUsers,
  getUsersHighlight,
  getUser,
  blockUser,
  unblockUser,
};
